export const superAdminConfig = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/dashboard`,
    linkedUrls: (params) => [
      `/stanford-admin/dashboard`, `/stanford-admin/group/create`,
      `/stanford-admin/organization/add`
    ],
    isSelected: false
  },
  {
    key: 'my-questionnaires',
    label: 'My Questionnaires',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/questionnaires/my-questionnaires`,
    linkedUrls: (params) => [
      `/stanford-admin/questionnaires/my-questionnaires`,
      `/stanford-admin/questionnaires/survey-questionnaires/${params.questionnaireId}`,
      `/stanford-admin/questionnaires/take-questionnaires/${params.questionnaireId}`
    ],
    isSelected: false,
  },
  {
    key: 'manageUsers',
    label: 'Manage Users',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/manage-users`,
    linkedUrls: (params) => [`/stanford-admin/manage-users`, `/stanford-admin/invite`],
    isSelected: false
  },
  {
    key: 'questionnaires',
    label: 'Manage Questionnaires',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/questionnaires/manage-questionnaires`,
    linkedUrls: (params) => [
      `/stanford-admin/questionnaires/manage-questionnaires`,
      `/stanford-admin/questionnaires/create-questionnaire-schedule`,
      `/stanford-admin/questionnaires/edit-questionnaire/${params.questionnaireId}`,
      `/stanford-admin/questionnaires/edit/create-questionnaire-schedule/${params.questionnaireId}`
    ],
    isSelected: false,
  },
  {
    key: 'resourceHub',
    label: 'Manage Resource Hub',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/resource-hub/resources-list`,
    linkedUrls: (params) => [
      `/stanford-admin/resource-hub/resources-list`,
      `/stanford-admin/resource-hub/add-resource`,
      `/stanford-admin/resource-hub/resource-details/${params.resourceId}/${params.slug}`,
      `/stanford-admin/resource-hub/edit-resource/${params.resourceId}/${params.slug}`
    ],
    isSelected: false,
  },
  {
    key: 'foodGuide',
    label: 'Manage Food Guide',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/manage-food-guide`,
    linkedUrls: (params) => [`/stanford-admin/manage-food-guide`],
    isSelected: false,
  },
  {
    key: 'reports',
    label: 'Reports',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/reports`,
    linkedUrls: (params) => [`/stanford-admin/reports`],
    isSelected: false,
  },
];

export const clientConfig = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization/${params.clientId}/dashboard`,
    linkedUrls: (params) => [`/stanford-admin/organization/${params.clientId}/dashboard`],
    isSelected: false
  },
  {
    key: 'clientDetails',
    label: 'Organization Details',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization/${params.clientId}/details`,
    linkedUrls: (params) => [`/stanford-admin/organization/${params.clientId}/details`],
    isSelected: false,
  },
  {
    key: 'clientQuestionnaire',
    label: 'Organization Questionnaire',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization/${params.clientId}/questionnaires/manage-questionnaires`,
    linkedUrls: (params) => [
      `/stanford-admin/organization/${params.clientId}/questionnaires/manage-questionnaires`,
      `/stanford-admin/organization/${params.clientId}/questionnaires/edit-questionnaire/${params.questionnaireId}`
    ],
    isSelected: false,
  },
];

export const clientAdminConfig = [
  {
    key: 'profile',
    label: 'Profile',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization-admin/${params.clientAdminId}/profile`,
    linkedUrls: (params) => [`/stanford-admin/organization-admin/${params.clientAdminId}/profile`],
    isSelected: false,
  },
  {
    key: 'dashboard',
    label: 'Dashboard',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization-admin/${params.clientAdminId}/dashboard`,
    linkedUrls: (params) => [`/stanford-admin/organization-admin/${params.clientAdminId}/dashboard`],
    isSelected: false
  },
  {
    key: 'clientDetails',
    label: 'Organization Details',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization-admin/${params.clientAdminId}/organization-details`,
    linkedUrls: (params) => [`/stanford-admin/organization-admin/${params.clientAdminId}/organization-details`],
    isSelected: false
  },
  {
    key: 'manageUsers',
    label: 'Manage Users',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/organization-admin/${params.clientAdminId}/manage-users`,
    linkedUrls: (params) => [`/stanford-admin/organization-admin/${params.clientAdminId}/manage-users`],
    isSelected: false
  },
  // TODO: Commenting this code block for now, but later might be needed as per the  comment from Rizwana on Ticket STAN-2017
  // {
  //   key: 'resourceHub',
  //   label: 'Resource Hub',
  //   isExpandable: false,
  //   children: [],
  //   link: (params) => `/stanford-admin/organization-admin/${params.clientAdminId}/resource-hub`,
  //   linkedUrls: (params) => [`/stanford-admin/organization-admin/${params.clientAdminId}/resource-hub`],
  //   isSelected: false,
  // }
]

export const coachConfig = [
  {
    key: 'profile',
    label: 'Profile',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/coach/${params.coachId}/profile`,
    linkedUrls: (params) => [`/stanford-admin/coach/${params.coachId}/profile`],
    isSelected: false,
  },
  {
    key: 'groups',
    label: 'Groups',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/coach/${params.coachId}/groups`,
    linkedUrls: (params) => [`/stanford-admin/coach/${params.coachId}/groups`],
    isSelected: false
  },
  {
    key: 'manageUsers',
    label: 'Manage Users',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/coach/${params.coachId}/manage-users`,
    linkedUrls: (params) => [`/stanford-admin/coach/${params.coachId}/manage-users`],
    isSelected: false
  },
  // TODO: Commenting this code block for now, but later might be needed as per the  comment from Rizwana on Ticket STAN-2017
  // {
  //   key: 'resourceHub',
  //   label: 'Resource Hub',
  //   isExpandable: false,
  //   children: [],
  //   link: (params) => `/stanford-admin/coach/${params.coachId}/resource-hub`,
  //   linkedUrls: (params) => [`/stanford-admin/coach/${params.coachId}/resource-hub`],
  //   isSelected: false
  // },
]

export const groupConfig = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/group/${params.groupId}/dashboard`,
    linkedUrls: (params) => [`/stanford-admin/group/${params.groupId}/dashboard`],
    isSelected: false,
  },
  {
    key: 'sessions',
    label: 'Sessions',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/group/${params.groupId}/sessions`,
    linkedUrls: (params) => [
      `/stanford-admin/group/${params.groupId}/sessions`,
      `/stanford-admin/group/${params.groupId}/sessions/${params.sessionId}/details`
    ],
    isSelected: false,
  },
  {
    key: 'details',
    label: 'Details',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/group/${params.groupId}/details`,
    linkedUrls: (params) => [`/stanford-admin/group/${params.groupId}/details`],
    isSelected: false,
  },
  {
    key: 'groupQuestionnaires',
    label: 'Group Questionnaires',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/group/${params.groupId}/questionnaires/manage-questionnaires`,
    linkedUrls: (params) => [`/stanford-admin/group/${params.groupId}/questionnaires/manage-questionnaires`],
    isSelected: false,
  },
];

export const memberConfig = [
  {
    key: 'profile',
    label: 'Profile',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/member/${params.memberId}/profile`,
    linkedUrls: (params) => [`/stanford-admin/member/${params.memberId}/profile`],
    isSelected: false,
  },
  {
    key: 'behaviorTracker',
    label: 'Behavior Tracker',
    isExpandable: true,
    children: [],
    link: (params) => `/stanford-admin/member/${params.memberId}/behavior-tracker`,
    linkedUrls: (params) => [`/stanford-admin/member/${params.memberId}/behavior-tracker`, `/stanford-admin/member/${params.memberId}/contract`],
    isExpanded: false,
    queryParamKey: 'weekNumber'
  },
  {
    key: 'journal',
    label: 'e-Journal',
    isExpandable: true,
    children: [],
    link: (params) => `/stanford-admin/member/${params.memberId}/my-journal`,
    linkedUrls: (params) => [`/stanford-admin/member/${params.memberId}/my-journal`],
    isExpanded: false,
    queryParamKey: 'weekNumber'
  },
  {
    key: 'metrics',
    label: 'Measurements',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/member/${params.memberId}/metrics`,
    linkedUrls: (params) => [`/stanford-admin/member/${params.memberId}/metrics`],
    isSelected: false
  },
  {
    key: 'progress',
    label: 'Progress',
    isExpandable: false,
    children: [],
    link: (params) => `/stanford-admin/member/${params.memberId}/progress`,
    linkedUrls: (params) => [`/stanford-admin/member/${params.memberId}/progress`],
    isSelected: false
  },
];
